export default __webpack_public_path__ + "static/media/invalid.6e0ea3b1.svg";